import React, { Component, Fragment } from "react";
import CalendarYear from "./calendarYear";

const calendarYrHolder = ({
  benchmark_name,
  typeName,
  display_orig_portfolio,
  model_name,
  calendar_yearly_data,
}) => {
  return (
    <Fragment>
      {calendar_yearly_data && calendar_yearly_data.length ? (
        <CalendarYear
          data={calendar_yearly_data}
          benchmark_name={benchmark_name}
          typeName={typeName}
          display_orig_portfolio={display_orig_portfolio}
          model_name={model_name}
        />
      ) : null}
    </Fragment>
  );
};
export default calendarYrHolder;



// WEBPACK FOOTER //
// ./src/components/PortfolioDashboard/navigationPages/performance/yearlyPerformance/calendarYrHolder.jsx